import { render, staticRenderFns } from "./Procesadas.vue?vue&type=template&id=5984545d&scoped=true"
import script from "./Procesadas.vue?vue&type=script&lang=js"
export * from "./Procesadas.vue?vue&type=script&lang=js"
import style0 from "./Procesadas.vue?vue&type=style&index=0&id=5984545d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5984545d",
  null
  
)

export default component.exports